// Links viejos de Drive (guardados antes de que el sitio sirviera las fotos por su cuenta).
const LEGACY_DRIVE_URL = /^https:\/\/drive\.google\.com\/uc\?export=view&id=([A-Za-z0-9_-]+)$/;

export function normalizeMediaUrl(value: string): string {
  const legacy = value.match(LEGACY_DRIVE_URL);
  const path = legacy ? `/api/drive-image/${legacy[1]}` : value;
  // Las rutas /api/... son relativas a la raiz; si el sitio vive bajo /borman/ hay que anteponer el prefijo.
  if (path.startsWith("/api/") && __BASE_PATH__ !== "/") {
    return __BASE_PATH__.replace(/\/$/, "") + path;
  }
  return path;
}

export function normalizeMediaUrls<T>(data: T): T {
  if (typeof data === "string") return normalizeMediaUrl(data) as T;
  if (Array.isArray(data)) return data.map((item) => normalizeMediaUrls(item)) as T;
  if (data && typeof data === "object") {
    return Object.fromEntries(Object.entries(data).map(([k, v]) => [k, normalizeMediaUrls(v)])) as T;
  }
  return data;
}
